<template lang="pug">
div.pad
  el-row(:gutter="30").marginTopHeader
    el-col(:span="8")
      validation-provider(rules="required|cpf", v-slot="{ errors }", :name="nomeAba + '/CPF'")
        app-label(label="CPF:")
        el-input.input(
          name='CPF',
          v-model="pessoa.pessoaFisica.cpf",
          v-mask="'###.###.###-##'",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Nome'")
        app-label(label="Nome:")
        el-input.input(
          name='Nome',
          v-model="pessoa.pessoaFisica.nome",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="8")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Matrícula'")
        app-label(label="Matrícula:")
        el-input.input(
          name='Matrícula',
          v-model="pessoa.pessoaFisica.matricula",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}
  el-row(:gutter="30")
    el-col(:span="8").marginTop
      app-input-telefone(
        :telefones="pessoa.telefones",
        :requiredTelefones="true"
        :nomeAba="nomeAba",
        :observer="observer"
      )
    el-col(:span="16").marginTop
      validation-provider(rules="required|email", v-slot="{ errors }", :name="nomeAba + '/E-mail'")
        app-label(label="E-mail:", rules="required")
        el-input.input(
          name="E-mail",
          v-model="pessoa.email",
          label='email',
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

</template>
<script>
import AppLabel from '@/components/AppLabel'
import AppInputTelefone from '@/components/AppInputTelefone'

export default {
  components: {
    AppLabel,
    AppInputTelefone
  },

  props: {
    pessoa: {
      type: Object,
      required: true
    },
    nomeAba: {
      type: String,
      required: true
    },
    observer: {
      type: Object
    }
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.select {
  width: 100%;
}

.full-width {
  width: 100%;
}

.marginTop {
  margin-top: 5px;
}

.marginTopHeader {
  margin-top: 15px;
}

/deep/ .tag-app-input i{
  color: #9BA0A9 !important;
}

/deep/ .tag-app-input i:hover {
  color: #F7F7F8 !important;
  background-color: #878D99 !important;
}

/deep/ .el-tag {
  margin-left: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #f3f4f5;
  border-color: #dddfe2;
  color: #9ba0a9 ;
}

/deep/ .style {
  color: #9ba0a9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppPessoaFisicaPrefeitura.vue